module.exports = __webpack_public_path__ + "media/images/light_yellow_edge-2a71630dd654704c7cd7d5d355d2889f.png";